module.exports = __webpack_public_path__ + "static/media/ImpactReport22-de.26da30d4.pdf";